<template>
    <div class="my-confirm-box show-confirm-box">
        <ul>
            <li class="content-box" v-html="confirmText">

            </li>

            <li>
                <div class="operation-box" >
                    <confirmButton type="success" @click="sureConfirm">
                        {{i18n.tkey("lang_sure")}}
                    </confirmButton>

                    <confirmButton type="danger" @click="cancelConfirm">
                        {{i18n.tkey("lang_cancel")}}
                    </confirmButton>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>

import ConfirmButton from "@/components/Shopopee3D/ui/confirmButton.vue";
import {inject} from "vue";

const props = defineProps(["confirmText"])
const emits = defineEmits(["clickSure", "clickCancel"])

const i18n = inject("i18n")

function sureConfirm(){
    emits("clickSure")
}

function cancelConfirm(){
    emits("clickCancel")
}

</script>

<style scoped>

ul{
    list-style: none;
    padding-left: 0;
    margin: 0;
}

@media screen and (min-width: 520px) {
    .my-confirm-box {
        position: fixed;
        width: 500px;
        height: 200px;
        background: #ffffff;
        left: calc(50vw - 280px);
        top: calc(50vh - 100px);
        z-index: 300;
        border-radius: 20px;
        border: #ddd 1px solid;
        padding: 2vw;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        text-align: left;
        cursor: default;
        user-select: none;

    }
}

@media screen and (max-width: 520px) {
    .my-confirm-box {
        position: fixed;
        width: 80%;
        height: 200px;
        background: #ffffff;
        left: calc(10% - 5px);
        top: calc(50vh - 100px);
        z-index: 300;
        border-radius: 20px;
        border: #ddd 1px solid;
        padding: 5px;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        text-align: left;
        cursor: default;
        user-select: none;

    }
}

@media screen and (min-width: 520px) {
    .my-confirm-box .content-box{
        height: 170px;
        line-height: 1.5;
        /*padding-bottom: 15px;*/
    }
}

@media screen and (max-width: 520px) {
    .my-confirm-box .content-box{
        height: 165px;
        line-height: 1.5;
        /*padding-bottom: 15px;*/
    }
}

.my-confirm-box .operation-box{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 30px;
    user-select: none;

}

.show-confirm-box {
    animation: show-confirm-animation 1.3s ease;
}

@keyframes show-confirm-animation {

    0% {
        transform: scaleX(0) scaleY(0.01);
    }

    33% {
        transform: scaleX(1) scaleY(0.01);
    }

    100% {
        transform: scaleX(1) scaleY(1);
    }

}


</style>